
import React from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

const NewsletterSubscribe = () => {
  return (
    <section id="subscribe" className="py-20 bg-gray-900 text-white">
      <div className="container px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Cut the noise. Make wiser hiring decisions.</h2>
          <p className="text-lg text-gray-300 mb-8">
            Get real insights from thousands of hiring companies and millions of premium candidates.
          </p>
          
          <a href="https://cutshort.io/a/newsletter-hs-form" target="_blank" rel="noopener noreferrer">
            <Button 
              className="bg-white text-gray-900 hover:bg-white/90 px-8 py-6 text-lg mx-auto"
            >
              Subscribe Now
            </Button>
          </a>
          
          <div className="mt-8">
            <p className="text-sm text-white font-medium mb-4">
              Trusted by 3.5 Million users and 40,000+ recruiters
            </p>
            <div className="flex flex-wrap justify-center gap-4 mt-4">
              {['No spam', 'Cancel anytime', 'Weekly delivery', 'Quality content'].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-gray-300">
                  <CheckCircle className="h-4 w-4 text-white" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSubscribe;

